import { Link } from 'react-router-dom';
import { GameLayout } from './GameLayout';

export function ComingSoon({ title }: { title: string }) {
  return (
    <GameLayout>
      <span className="label">/ Скоро</span>
      <h1 style={{ fontFamily: 'Oswald', fontWeight: 600, fontSize: 80, lineHeight: 1.02, margin: '12px 0 20px', letterSpacing: '-.015em' }}>
        {title}
      </h1>
      <p style={{ maxWidth: 480, color: 'var(--ink-dim)', fontSize: 17, lineHeight: 1.55, margin: '0 0 32px' }}>
        Эта игра ещё в разработке. Пока играем в Мафия Live — она уже работает от и до.
      </p>
      <Link to="/play/mafia" className="btn-primary lg">
        Играть в Мафия Live →
      </Link>
    </GameLayout>
  );
}
